import React, { useState } from "react";
import axios from "axios";
import AdminNavigation from "./AdminNavigation";
import { ToastContainer, toast } from "react-toastify";

const CreateMeeting = () => {
  const [meetingTime, setMeetingTime] = useState("");
  const [meetingDuration, setMeetingDuration] = useState("30"); // Default to 30 minutes
  const [meetingUrl, setMeetingUrl] = useState(""); // Store Join URL
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const createMeeting = async () => {
    if (!meetingTime) {
      setError("Please select a meeting time.");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const storedLoginResponse = localStorage.getItem("loginResponse");
      const loginResponse = storedLoginResponse
        ? JSON.parse(storedLoginResponse)
        : null;

      const token = loginResponse?.data?.tokan;
      if (!token) {
        setError("Token not found. Please log in again.");
        setIsLoading(false);
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/zoom/create-meeting`,
        {
          userId: "00", // Replace with actual user ID
          ladiesId: "00", // Replace with actual ladies ID
          meetingDuration, // Selected duration from radio button
          svcId: "00", // Replace with actual service ID
          meetingDateTime: meetingTime.split("T").map((part, index) => {
            if (index === 0) return part.split("-").map(Number); // [year, month, day]
            return part.split(":").map(Number); // [hour, minute, second]
          }).flat(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const meetingData = response?.data?.data?.meetingdata;
      const joinUrl = meetingData?.join_url;

      setMeetingUrl(joinUrl); // Store Join URL
      toast.success("Meeting created successfully!");

      // Reset form fields but keep the Join URL visible
      setMeetingTime("");
      setMeetingDuration("30");
    } catch (error) {
      console.error("Error creating Zoom meeting:", error);
      setError(
        error.response?.data?.message ||
        "An error occurred while creating the meeting."
      );
    }

    setIsLoading(false);
  };

  // Function to Copy URL to Clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(meetingUrl);
    toast.success("Meeting URL copied!");
  };

  return (
    <>
      <ToastContainer />
      <div id="wrapper" className="toggled">
        <AdminNavigation />
        <div id="page-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-lg-offset-2">
                <h3>Add A Meeting</h3>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <form
                  className="mt-4"
                  onSubmit={(e) => {
                    e.preventDefault();
                    createMeeting();
                  }}
                >
                  {/* Select Meeting Time */}
                  <div className="mb-3">
                    <label htmlFor="meetingTime" className="form-label">
                      Meeting Time:
                    </label>
                    <input
                      type="datetime-local"
                      id="meetingTime"
                      className="form-control"
                      value={meetingTime}
                      onChange={(e) => setMeetingTime(e.target.value)}
                    />
                  </div>

                  {/* Select Meeting Duration */}
                  <div className="mb-3">
                    <label className="form-label">Meeting Duration:</label>
                    <div>
                      <input
                        type="radio"
                        id="duration30"
                        name="meetingDuration"
                        value="30"
                        checked={meetingDuration === "30"}
                        onChange={(e) => setMeetingDuration(e.target.value)}
                      />
                      <label htmlFor="duration30" className="ms-2 me-3">
                        30 Minutes
                      </label>

                      <input
                        type="radio"
                        id="duration60"
                        name="meetingDuration"
                        value="60"
                        checked={meetingDuration === "60"}
                        onChange={(e) => setMeetingDuration(e.target.value)}
                      />
                      <label htmlFor="duration60" className="ms-2">
                        60 Minutes
                      </label>
                    </div>
                  </div>

                  {/* Create Meeting Button */}
                  <button type="submit" className="btn btn-primary" disabled={isLoading}>
                    {isLoading ? "Creating..." : "Create Meeting"}
                  </button>
                </form>

                {/* Display Meeting URL After Creation */}
                {meetingUrl && (
                  <div className="mt-4">
                    <label>Meeting Join URL:</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        value={meetingUrl}
                        readOnly
                      />
                      <button className="btn btn-success" onClick={copyToClipboard}>
                        Copy
                      </button>
                    </div>
                    <div className="mt-2">
                      <a href={meetingUrl} target="_blank" rel="noopener noreferrer">
                        Click here to join the meeting
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateMeeting;
